export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewRole(state, { payload }) {
    state.roles = [...state.roles, ...[payload]];
  },

  delProperty(state, { property }) {
    state.roles = state.roles.filter(el => el.id !== property);
  },
};
